import { createAction } from 'redux-actions';

export const dashboardSetShowThankYouModal = createAction(
  'dashboard/set-show-thank-you-modal',
);
